import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationStatuses extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!organizationId) {
            throw new Error('[ModerationHistory] OrganizationId is mandatory');
        }
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/status`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/status`;
    }

    toOptions(flowId) {
        if (!flowId) {
            return {
                key: this.id,
                value: this.stage,
                text: `${this.flow.name} - ${this.name}`,
                name: String(this.id)
            };
        }
        return {
            key: this.id,
            value: this.stage,
            text: this.name,
            name: String(this.id)
        };
    }
}
